module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deposit notices"},"et":{"title":"Deposit notices"},"ru":{"title":"Deposit notices"}}')
  delete Component.options._Ctor
}
